<template>
  <div>
    <app-loading v-bind:loading="loading"></app-loading>
    <app-navigation v-bind:active-lot="activeLot"></app-navigation>
    <div class="layout">
      <div class="layout-item lot-panel" v-if="lotView">
        <app-land-list v-if="lotload" v-bind:landSummary="lotload" v-on:setActiveLot="flyTo($event.lotcpid, false)"></app-land-list>
      </div>
      <div class="layout-item grow">
        <div id="map" ref="community-map">
          <div class="custom-control">
            <a @click="toggle3d()">
              <img src="@/assets/icons/td.svg" alt="">
            </a>
          </div>

          <app-map-label></app-map-label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Map from "@/mixins/journey/Map";
import LandPanel from "@/components/journey/land/LandPanel";
import Navigation from "@/components/journey/nav/Navigation";
import Loading from "@/components/journey/Loading";
import MapLabel from "@/components/journey/MapLabel";
import Swal from "sweetalert2";

export default {
  name: 'app-community-map',
  mixins: [Map],
  components: {
    'app-navigation': Navigation,
    'app-land-list': LandPanel,
    'app-loading': Loading,
    'app-map-label': MapLabel
  },
  data() {
    return {
      activeClick: null,
      activeHome: null,
      container: 'community-map',
      homesummary: null,
      initiatedMap: false,
      isPitched: false,
      loading: true,
      lotload: null,
      lotView: true,
      masterplanConfig: null,
      masterplanResources: null,
      modelHomes: [],
      sub: null
    }
  },
  watch: {},
  beforeDestroy() {
    if (this.map) {
      this.map.remove();
    }
    this.sub();
  },
  mounted: function () {
    if (this.$store.getters.masterplanConfig) {
      this.masterplanConfig = this.$store.getters.masterplanConfig;
      this.loadMap();
    } else {
      this.$store.dispatch('fetchMasterplanConfig')
    }
    this.initSubscription();
    this.$store.dispatch('getPackageDetailList');
  },
  created() {
  },
  methods: {
    initSubscription: function () {
      this.sub = this.$store.subscribe((mutation, state) => {
        if (mutation.type === 'setMasterplanConfig') {
          this.masterplanConfig = this.$store.getters.masterplanConfig;
          this.loadMap();
        }
        if (mutation.type === 'setPackageDetailList') {
          if(state.communityStore.packageDetailList && state.communityStore.packageDetailList.length){
              this.loading = false;
              this.packageSummaryList = state.communityStore.packageDetailList;
          }
        }

        if (mutation.type === 'setCompatibleLotSummaryList') {
          this.homesummary = state.communityStore.homeDetail;
          const lotsummary = state.communityStore.compatibleLotSummary;
          this.lotload = [];
          if (lotsummary) {
            this.lotload = lotsummary.filter( item => item.monotonyConflict === false && item.active);
          }
          if(this.lotload.length === 0){
            Swal.fire({
              icon: "error",
              title: "There are no compatible lots for the floorplan you have selected. ",
              allowOutsideClick: 'false'
            }).then( res => {
              if(res.isConfirmed){
                this.goBack()
              }
            })
          }
          this.loadMap();
        }

        if (mutation.type === 'setUnfilteredSummaryList') {
          this.lotload = [];
          this.modelHomes = state.communityStore.modelHomes;
          state.communityStore.unfilteredLotSummary.forEach(item => {
            if (item.lotgroup) {
              item.lotgroup = item.lotgroup.replace('ft', "'");
            }
            this.lotload.push(item);
          });
          this.loadMap();
        }

        if (mutation.type === 'setLotSummaryList') {
          this.filterMapLots(state.communityStore.lotsummary)
        }
      })
      this.getIds();
    },

    getIds: function () {
      const query = this.$route.query;
      if (query.homeid && query.facadeid) {
        this.activeHome = {
          homeid: query.homeid,
          facadeid: query.facadeid,
          plancpid: query.plancpid
        }
        this.getCompatibleLots()
        return this.selector = 'lot'
      }
      this.getLots();
      return this.selector = 'home'
    },

    getCompatibleLots: function () {
      this.$store.dispatch('fetchCompatibleLotSummaryList', this.activeHome)
    },

    getLots: function () {
      this.$store.dispatch('fetchLotSummaryList')
    },

    selectLot: function () {
      this.activeClick = null;
    },

    loadMap: function () {
      if (!this.initiatedMap && this.masterplanConfig && this.lotload) {
        this.initiatedMap = true;
        this.initMap(this.masterplanConfig, this.lotload, this.modelHomes);
      }
    },

    toggle3d: function () {
      const pitch = this.isPitched ? 0 : 60
      this.isPitched = !this.isPitched;
      this.map.flyTo({
        pitch: pitch
      });
    },

    goBack: function () {
      return this.$router.push({
        path: '/community/homes',
      })
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/journey/Map.vue